"use strict";

/**
 * @generated SignedSource<<06c731213a26224d422c464e9aa2f31c>>
 * @relayHash 7cab1f549b9f492c27d3864d38c0fdc6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0399a9ff95188def0f24ebe19957d6114a85ca65d3124e64b62b9bd810406cc

const node = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "businessName"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "businessType"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "city"
    },
    v3 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "emailAddress"
    },
    v4 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "name"
    },
    v5 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "phoneNumber"
    },
    v6 = [{
      "alias": null,
      "args": [{
        "fields": [{
          "kind": "Variable",
          "name": "businessName",
          "variableName": "businessName"
        }, {
          "kind": "Variable",
          "name": "businessType",
          "variableName": "businessType"
        }, {
          "kind": "Variable",
          "name": "city",
          "variableName": "city"
        }, {
          "kind": "Variable",
          "name": "emailAddress",
          "variableName": "emailAddress"
        }, {
          "kind": "Variable",
          "name": "name",
          "variableName": "name"
        }, {
          "kind": "Variable",
          "name": "phoneNumber",
          "variableName": "phoneNumber"
        }],
        "kind": "ObjectValue",
        "name": "input"
      }],
      "concreteType": "OutputObject",
      "kind": "LinkedField",
      "name": "submitSupplierGeneralEnquiry",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "completedAt",
        "storageKey": null
      }],
      "storageKey": null
    }];
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/, v3 /*: any*/, v4 /*: any*/, v5 /*: any*/],
      "kind": "Fragment",
      "metadata": null,
      "name": "LearnMoreNZRequestSubmit_Mutation",
      "selections": v6 /*: any*/,
      "type": "Mutation",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v4 /*: any*/, v5 /*: any*/, v3 /*: any*/, v0 /*: any*/, v2 /*: any*/, v1 /*: any*/],
      "kind": "Operation",
      "name": "LearnMoreNZRequestSubmit_Mutation",
      "selections": v6 /*: any*/
    },
    "params": {
      "id": "a0399a9ff95188def0f24ebe19957d6114a85ca65d3124e64b62b9bd810406cc",
      "metadata": {},
      "name": "LearnMoreNZRequestSubmit_Mutation",
      "operationKind": "mutation",
      "text": null
    }
  };
}();
node.hash = "24ec13065631f9e9d8d92f4a3bfec839";
export default node;